/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

$('form#newsletter-popup').submit( function(){
  $('p.error, p.success').remove();
  if($(this).find('input[type="email"]').val() !== ''){
    var data = $(this).serialize();
    $.ajax({  
      type: "POST",  
      url: "/contact",  
      data: data,  
      success: function() { 
        $('.contact-form').append('<p class="success">Thanks for signing up! Here is your promo code: 123456</p>');
      },
      error: function() {
        $('.contact-form').append('<p class="errror">There was an error in submitting the form.</p>');
      }    
    }); 
  }
  else {
    $(this).append('<p class="error">Please fill in your email address.</p>');  
  }
  return false;
});


$(document).ready(function(){
  $(".single-cat").click(function(){
    var pageIndex=$(this).index();
    $next=$(".cat-faq").eq(pageIndex);
    $(".cat-faq.active").removeClass("active");
    $(".single-cat.active").removeClass("active");
    $(this).addClass("active");
    $next.addClass("active");
  });
  $(".Timeline__NavItem").on("click", function(e){
    e.preventDefault();
    let index = $(this).data("index");
    $(this).parents(".Timeline").find(".Timeline__NavItem").removeClass("is-selected");
    $(this).addClass("is-selected");
    $(this).parents(".Timeline").find(".Timeline__Item").removeClass("is-selected");
    $(this).parents(".Timeline").find(".Timeline__Item[data-index='"+index+"']").addClass("is-selected");
  });
});


$( function() {
  
  var $gallery = $('.image_hotspot-carousel').flickity({
    cellAlign: "center", 
    contain: true, 
    pageDots: true, 
    prevNextButtons: false
  });

  var flickity = $gallery.data('flickity');
  
  var $galleryNav = $('.image_hotspot-thumb');
  var $galleryNavItems = $galleryNav.find('li');
  
  $gallery.on( 'select.flickity', function() {
    $galleryNav.find('.is-selected').removeClass('is-selected');
    $galleryNavItems.eq( flickity.selectedIndex ).addClass('is-selected');
  });
  
  $galleryNav.on( 'click', 'li', function() {
    var index = $(this).index();
    $gallery.flickity( 'select', index );
  });
  
});

$('.counter').counterUp({
  delay: 10,
  time: 2000
});


